import imageUrlBuilder from '@sanity/image-url';

type CdnUrlImageOptions = {
  width?: number;
  asIs?: boolean;
};

/** Default options for generating image URLs */
const defaults = {
  width: 1600, // Default width if not specified
  asIs: false,
};

const defaultUrlForOptions: Readonly<AllCdnUrlImageOptions> = Object.freeze(defaults);
type AllCdnUrlImageOptions = Required<CdnUrlImageOptions>;

export { type CdnUrlImageOptions, type AllCdnUrlImageOptions };

// TODO rename this to imageUrlFor
export function urlFor(source?: string, options?: CdnUrlImageOptions): string {
  if (!source) return '';
  if (options?.asIs) {
    const sanity = useSanity();
    const builder = imageUrlBuilder(sanity.client);
    const imageUrl = new URL(builder.image(source).url());
    const { pathname } = imageUrl;
    const imageFilename = pathname.split('/').pop();
    const newUrl = new URL(`https://www.onshape.com/cdn-images/${imageFilename}`);
    return newUrl.href;
  }

  const ops: AllCdnUrlImageOptions = { ...defaultUrlForOptions, ...options };

  const sanity = useSanity();
  const builder = imageUrlBuilder(sanity.client);
  const imageUrl = new URL(builder.image(source).format('webp').width(ops.width).url());
  const { pathname, searchParams } = imageUrl;
  const imageFilename = pathname.split('/').pop();
  const newUrl = new URL(`https://www.onshape.com/cdn-images/${imageFilename}`);
  const isSvg = imageFilename?.endsWith('.svg');
  searchParams.forEach((value, key) => {
    if (isSvg && key === 'fm') return;
    newUrl.searchParams.set(key, value);
  });
  return newUrl.pathname + newUrl.search;
}
